module.exports = __webpack_public_path__ + "static/media/sub_icon.96ab2c00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sub_icon.svg
// module id = 1176
// module chunks = 0